import React from "react";
import { Helmet } from "react-helmet";
import Navbar from '../components/navbar';
import TopBanner from '../components/top-banner';
import Footer from '../components/footer';
import Contact from "../components/contact-us";
import Destinations from "../components/destinations";
import SocialMediaFixed from "../components/socialmedia-fixed";


const DestinationsPage = () => {

    return (
        <>
            <Helmet>
                <title>Top Destinations in Madhya Pradesh - Explore Heritage, Wildlife & Pilgrimage</title>
                <meta name="description" content="Discover the best destinations in Madhya Pradesh with MP Holidays. Explore heritage sites, wildlife sanctuaries, spiritual places, and adventure destinations with our expertly curated travel packages." />
                <meta name="keywords" content="Madhya Pradesh destinations, top places to visit MP, heritage sites MP, wildlife sanctuaries MP, pilgrimage places MP, adventure tourism MP, MP travel guide, MP tourism, best tourist spots MP" />
                <link rel="canonical" href="https://mpholidays.online/destinations" />

                {/* JSON-LD structured data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "TravelAgency",
                        "name": "MP Holidays - Explore Top Destinations in Madhya Pradesh",
                        "url": "https://mpholidays.online/destinations",
                        "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "+91 9319184060",
                            "contactType": "Customer Support"
                        },
                        "description": "Explore the best destinations in Madhya Pradesh, including heritage, wildlife, pilgrimage, and adventure spots, with MP Holidays' expert travel planning.",
                    })}
                </script>
            </Helmet>


            <TopBanner />
            <Navbar />
            <Destinations />
            <Footer />
            <SocialMediaFixed />
        </>
    );
};

export default DestinationsPage;
